const baseUrl = 'https://redspeedapi.redstarplc.com/api'
export default baseUrl;

// Login
// ximitap903@keyido.com
// password:password
